/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ProgressionCoursesTypes, ProgressionCourseState } from './types';

const INITIAL_STATE: ProgressionCourseState = {
  progression_course: {
    last_lasson: {
      created_at: 0,
      id: 0,
      nome: '',
      status_id: false,
      updated_at: '',
      order: 0,
      topic_id: 0,
      url_video: '',
      ordem: 0,
      free: false,
    },
    progression: 0,
    total_aula: 0,
    next: [],
    previous: [],
    concluded: false,
    total_completed: 0,
  },
  request: {
    get_progression_course: {
      loading: false,
      loaded: false,
      error: false,
    },
    previous_Class: {
      loading: false,
      loaded: false,
      error: false,
    },
    class_current_status: {
      loading: false,
      loaded: false,
      error: false,
    },
    count_topics: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};
const reducer: Reducer<ProgressionCourseState> = (
  state = INITIAL_STATE,
  { type, result, last_class },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ProgressionCoursesTypes.GET_PROGRESSION_REQUEST:
        draft.request.get_progression_course = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.GET_PROGRESSION_SUCCESS:
        draft.progression_course.last_lasson = result?.data?.get_last_class?.last_class;
        draft.progression_course.progression = result?.data?.get_last_class?.progression;
        draft.progression_course.total_aula = result?.data?.get_last_class?.total_aula;
        draft.request.get_progression_course = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.GET_PROGRESSION_FAILURE:
        draft.request.get_progression_course = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProgressionCoursesTypes.PREVIOUS_CLASS_REQUEST:
        draft.request.previous_Class = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.PREVIOUS_CLASS_SUCCESS:
        draft.progression_course.next = result?.data?.next_previous?.next;
        draft.progression_course.previous = result?.data?.next_previous?.previous;
        draft.request.previous_Class = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.PREVIOUS_CLASS_FAILURE:
        draft.request.previous_Class = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProgressionCoursesTypes.CURRENT_CLASS_STATUS_REQUEST:
        draft.request.class_current_status = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.CURRENT_CLASS_STATUS_SUCCESS:
        draft.progression_course.concluded = result?.data[0]?.concluded;
        draft.request.class_current_status = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.CURRENT_CLASS_STATUS_FAILURE:
        draft.request.class_current_status = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProgressionCoursesTypes.TOTAL_COMPLETED_REQUEST:
        draft.request.count_topics = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.TOTAL_COMPLETED_SUCCESS:
        draft.progression_course.total_completed = result?.data;
        draft.request.count_topics = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProgressionCoursesTypes.TOTAL_COMPLETED_FAILURE:
        draft.request.count_topics = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProgressionCoursesTypes.LAST_CLASS:
        draft.progression_course.last_lasson = last_class;
        break;
      default:
    }
  });
};
export default reducer;
